import { Instance, applySnapshot, flow, types } from 'mobx-state-tree';

import { getCurrentLearningFlow } from '@common/api/currentLearningFlow';

const CurrentLearningFlowModel = types
	.model('CurrentLearningFlowModel', {
		name: types.optional(types.maybeNull(types.string), ''),
		study_direction: types.optional(types.string, ''),
		entry_grade: types.optional(types.string, ''),
	})
	.volatile(() => ({
		loading: false,
		hasError: false,
	}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			self.hasError = false;

			try {
				const result = yield getCurrentLearningFlow();
				applySnapshot(self, result || {});
			} catch (error) {
				self.hasError = true;
				console.error(error);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default CurrentLearningFlowModel;

export interface ICurrentLearningFlowModel extends Instance<typeof CurrentLearningFlowModel> {}
